const selectors = {
  dataGridItemVariant: 'data-grid-item-variant',
  dataGridImageTarget: 'data-grid-image-target',
  dataSwatchGridImageIndex: 'data-grid-image',
  dataGridImage: 'data-grid-image',
  dataSwatchImageId: 'data-swatch-image-id',
  dataSwatchIndex: 'data-swatch-index',
};

class ProductGridItem extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.gridItemVariantLinks = this.container.querySelectorAll(`a[${selectors.dataGridItemVariant}]`);
  }

  connectedCallback() {
    if (this.gridItemVariantLinks.length) {
      this.gridItemVariantLinks.forEach((element) => {
        if (!element.hasAttribute(selectors.dataGridItemVariant)) return;

        this.swatchHoverEvent(element);
        this.swatchClickEvent(element);
      });
    }
  }

  swatchHoverEvent(swatchLink) {
    swatchLink.addEventListener('mouseenter', () => {
      if (swatchLink.hasAttribute(selectors.dataGridItemVariant)) {
        const product = swatchLink.getAttribute(selectors.dataGridItemVariant);

        // Ensure all images are loaded for this swatch
        this.container.querySelectorAll(`product-grid-item-variant[${selectors.dataGridItemVariant}="${product}"] product-grid-item-image`).forEach((image) => {
          image.setAttribute('loading', 'eager');
        });
      }
    });
  }

  swatchClickEvent(swatchLink) {
    swatchLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.container.querySelectorAll(`a[${selectors.dataGridItemVariant}]`).forEach((link) => link.removeAttribute('aria-selected'));

      swatchLink.setAttribute('aria-selected', 'true');

      if (swatchLink.hasAttribute(selectors.dataGridItemVariant)) {
        const swatchLinkVariant = swatchLink.getAttribute(selectors.dataGridItemVariant);
        // Show content for swatch
        this.container.querySelectorAll(`product-grid-item-variant[${selectors.dataGridItemVariant}]`).forEach((swatchElement) => {
          const swatchElementVariant = swatchElement.getAttribute(selectors.dataGridItemVariant);

          if (swatchElementVariant === swatchLinkVariant) {
            swatchElement.removeAttribute('hidden');
          } else {
            swatchElement.setAttribute('hidden', '');
          }
        });
      }
    });
  }
}

export {ProductGridItem};
